
const Bridge = {
    callbacks: {},

        _getHighResTimestamp: function() {
            if (window.performance && window.performance.now) {
                return Math.floor(performance.now() * 1000);
            }
            return Date.now();
        },

        _generateCallbackName: function() {
            const uuid = ([1e7]+1e3+4e3+8e3+1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
            return `bridge_${uuid}`;
        },

       invoke(functionName, params, callback) {
               const cbId = callback ? this._generateCallbackName() : null;
               if(cbId) this.callbacks[cbId] = callback;

               const message = {
                   functionName,
                   params: typeof params === 'string' ? params : JSON.stringify(params || {}),
                   complete: cbId
               };
               prompt(JSON.stringify(message));
           },


    _trigger(cbId, response) {
        const cb = this.callbacks[cbId];
        console.log("find callback for id:", cbId, cb);
        if(cb) {
            try { cb(response); } catch(e) { console.error(e); }
            delete this.callbacks[cbId];
        } else {
            console.warn('bridge callback not exist', cbId);
        }
    }
};



export function setBridge() {
  window.Bridge = Bridge;
}